<template>
  <div class="box3">
    <div class="top-box">
      <pageTitle 
        title="有真实力 学员更受企业青睐"
        text="实力铸就自信，技能赢得未来"
        titleColor="#FFF"
        titColor="#FFF" />
    </div>
    <div class="subject-content">
      <div class="nav-box">
        <div class="nav"
          :class="{ 'cur-nav': cur == index }" 
          v-for="(item, index) in navList" 
          :key="index"
          @click="changeCur(index)">
          <p>{{cur == index ? item.curName : item.name}}</p>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide class="swiperwrap">
          <div class="item-wrapper">
						<div class="item">
							<img class="img1" src="../../../assets/coursePage/harmony/box3/1-5.png" alt="" />
							<div class="text">
								<p>黑马鸿蒙课程多个项目</p>
								<p>获得2024华为官方大奖</p>
							</div>
              <swiper :options="picOption" class="swiper-container3" ref="swiperContainer3">
                <swiper-slide v-for="(image, index) in imgList" :key="index">
                  <img class="img2" :src="image" alt="" />
                </swiper-slide>
              </swiper>
							<div class="wrapper1">
								<div class="title-wrapper" :class="{'right-title-wrapper': proCur === 1}">
									<span 
                    v-for="(item, index) in projectList" 
                    :key="index"
                    :class="{'active': proCur === index}"
                    @click="changeProCur(index)"
                  >
                    {{ item.name }}
                  </span>
								</div>
								<div 
                  v-for="(item, index) in projectList" 
                  :key="index"
                  class="content-wrapper"
                  :class="{'content2': proCur !== index}"
                >
                  <div class="left">
                    <div class="p1">
                      <p>{{ item.projectName }}</p>
                      <p>{{ item.platform }}</p>
                      <p>{{ item.status }}</p>
                    </div>
                    <div class="p2">
                      <p>{{ item.learningBenefit1 }}</p>
                      <p>{{ item.learningBenefit2 }}</p>
                    </div>
                  </div>
                  <img :src="item.image" :alt="item.projectName" />
                </div>
							</div>
						</div>
						
					</div>
          <div class="seek-btn" @click="openDetail('学习华为获奖项目')">
            学习华为获奖项目
          </div>
        </swiper-slide>
        <swiper-slide class="swiperwrap">
          <div class="item-wrapper">
						<div class="item">
							<img class="img1" src="../../../assets/coursePage/harmony/box3/2-4.png" alt="" />
							<div class="text">
								<p>权威鸿蒙老师教研教学</p>
								<p>跟大神学习让你成为技术牛人</p>
							</div>
							<swiper :options="picOption2" class="swiper-container3">
                <swiper-slide v-for="(image, index) in imgList2" :key="index">
                  <img class="img2" :src="image" alt="" />
                </swiper-slide>
              </swiper>
							<img style="margin-top: 0.6rem;" class="img1" src="../../../assets/coursePage/harmony/box3/2-5.png" alt="" />
						</div>
						
					</div>
          <div class="seek-btn" @click="openDetail('和老师一对一聊聊')">
            和老师一对一聊聊
          </div>
        </swiper-slide>
        <swiper-slide class="swiperwrap">
          <div class="item-wrapper">
						<div class="item">
							<img class="img1" src="../../../assets/coursePage/harmony/box3/3-1.png" alt="" />
							<div class="text">
								<p>华为认证培训合作单位</p>
								<p>整合华为资源共建课程</p>
							</div>
							<img style="margin-top: 0.6rem;" class="img1" src="../../../assets/coursePage/harmony/box3/3-2.png" alt="" />
						</div>
						
					</div>
          <div class="seek-btn" @click="openDetail('了解华为合作详情')">
            了解华为合作详情
          </div>	
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    let that = this;
    return {
      cur: 0,
      navList: [
        { name: "好项目", curName: "华为获奖的好项目" },
        { name: "好老师", curName: "华为认可的好老师" },
        { name: "好课程", curName: "华为共建的好课程" }
      ],
      swiperOption: {
        loop: true, // 循环模式选项
        // slidesPerView: "auto",
        spaceBetween: 15,
        centeredSlides: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
        //   disableOnInteraction: false,
        // },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
          }
        },
      },
      picOption: {
        loop: false, // 循环模式选项
        slidesPerView: 1.6,
      },
      imgList: [
        require("../../../assets/coursePage/harmony/box3/1-1.png"),
        require("../../../assets/coursePage/harmony/box3/1-2.png"),
        require("../../../assets/coursePage/harmony/box3/1-3.png"),
        require("../../../assets/coursePage/harmony/box3/1-4.png")
      ],
      picOption2: {
        loop: false, // 循环模式选项，可根据需求修改
        slidesPerView: 1.6,
      },
      imgList2: [
        require("../../../assets/coursePage/harmony/box3/2-1.png"),
        require("../../../assets/coursePage/harmony/box3/2-2.png"),
        require("../../../assets/coursePage/harmony/box3/2-3.png")
      ],
      projectList: [
        { 
          name: "面试通",
          projectName: '《面试通》项目',
          platform: '在华为HarmonyOS NEXT',
          status: '应用市场正式上架',
          learningBenefit1: '学华为市场上架项目',
          learningBenefit2: '打造一线实战能力',
          image: require('../../../assets/coursePage/harmony/box3/面试.png')
        },
        { 
          name: "益康养老",
          projectName: '《益康养老》项目',
          platform: '被华为官网Codelab收录，',
          status: '开源供所有开发者学习',
          learningBenefit1: '学华为官网开源项目',
          learningBenefit2: '掌握前沿开发技术',
          image: require('../../../assets/coursePage/harmony/box3/养老.png')
        }
      ],
      proCur: 0 
    } 
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index + 1, 0, false);
      this.cur = index;
    },
    openDetail(name) {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("鸿蒙-就业课",name,0,null)
    },
    changeProCur(index) {
      this.proCur = index; 
    }
  },
};
</script>

<style lang="less" scoped>
.box3 {
  width: 100%;
  overflow: hidden;
  .top-box {
    box-sizing: border-box;
    padding-top: 77px;
    width: 750px;
    height: 200px;
    background: url("../../../assets/coursePage/harmony/box3/bg1.png") no-repeat center;
    background-size: cover;
  }
  .subject-content {
    width: 100%;
    .nav-box {
      box-sizing: border-box;
      padding: 56px 30px 6px;
      width: 750px;
      height: 138px;
      background: #002BFF;
      display: flex;
      justify-content: space-between;
      .nav {
        p {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 44px;
          height: 76px;
          font-weight: 600;
          font-size: 30px;
          color: #FFFFFF;
          line-height: 30px;
        }
      }
      .cur-nav {
        p {
          position: relative;
          background: #4D6AFF;
          border-radius: 12px;
          &::after {
            z-index: 100;
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: -18px;
            margin: 0 auto;
            width: 0;
            height: 0;
            border-left: 10px solid transparent; // 左边框宽度为 10px，透明色
            border-right: 10px solid transparent; // 右边框宽度为 10px，透明色
            border-top: 10px solid #002BFF;
          }
        } 
      }
    }
    
    .swiperitems {
      padding: 40px 60px 30px;
      box-sizing: border-box;
      background: url('../../../assets/coursePage/harmony/box3/bg2.png');
      background-size: 100% 100%;
      .item-wrapper {
        width: 630px;
        background: #FFFFFF;
        border-radius: 30px;
      }
      .item{
        flex: 1;
        height: 1350px;
        padding: 30px;
        .img1{
          width: 570px;
        }
        .img2{
          width: 330px;
        }
        .text{
          margin: 40px 0 44px 0;
          p{
            font-weight: 600;
            font-size: 36px;
            color: #000D4D;
            text-align: center;
            line-height: 54px;
          }
        }
        .swiper-container3{
          box-sizing: border-box;
          .swiper-wrapper{
            .swiper-slide{
              left: 0;
              transform: translateX(0)
            }
          }
        }
        .wrapper1{
          width: 570px;
          height: 415px;
          background: #4060FF ;
          margin-top: 60px;
          border-radius: 30px 30px 20px 20px;
          overflow: hidden;
          .title-wrapper{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            height: 120px;
            margin-top: 10px;
            background: url('../../../assets/coursePage/harmony/box3/1.png');
            background-size: 100% 100%;
            font-weight: 500;
            font-size: 28px;
            border-radius: 30px 30px 0 0;
            span{
              width: 50%;
              text-align: center;
              margin-top: 25px;
              color: #FFFFFF;
            }
            .active{
              color: #002BFF;
            }
          }
          .right-title-wrapper{
            background: url('../../../assets/coursePage/harmony/box3/2.png');
            background-size: 100% 100%;
          }
          .content-wrapper{
            display: flex;
            height: 296px;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
            padding-left: 24px;
            background: #F5F7FF;
            color: #000D4D;
            .left{
              p{
                font-size: 24px;
                white-space: nowrap;
                line-height: 40px;
              }
              .p1{
                font-weight: 500;
                color: #000933;
                margin-bottom: 40px;
              }
              .p2{
                color: #002BFF;
              }
            }
            img{
              width: 243px;
              height: 244px;
            }
          }
          .content2{
            display: none
          }
        }
      }
    }
  }
  .seek-btn {
    margin: 50px auto 0;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>
